import React from "react";
import "./dashboardSection.css";

const DashboardBlogTable = () => {
  return (
    <div className="dashboradBlogTableContainer">
      <div className="dashboardAllBlogTable column" />
      <div className="newchart column" />
    </div>
  );
};

export default DashboardBlogTable;
